import ContactPage from './contactPage.component';

export default ContactPage;